import {
  MISSION_ATTEMPT_EXIT_REASON_KEY,
  MISSION_ATTEMPT_PENDING_END_KEY,
  MISSION_ATTEMPT_SESSION_KEY
} from '@/constants/missionAttemptEndReasons'

export const AUTH_SESSION_MAX_AGE_DAYS = 15

export const AUTH_SESSION_MAX_AGE_MS =
  AUTH_SESSION_MAX_AGE_DAYS * 24 * 60 * 60 * 1000

export const AUTH_SESSION_STARTED_KEY = 'digipalz_auth_session_started_at'

export const AUTH_LOCAL_STORAGE_KEYS = [
  AUTH_SESSION_STARTED_KEY,
  'selectedProfile',
  'currentMissionContext',
  'pendingLevelUp',
  'verificationBannerDismissed',
  'digipalz_has_session_before',
  'mission_notes',
  'fc_scores_v1',
  'digipalz_chunk_reload_attempted',
  'digipalz_journey_user_type',
  'digipalz_journey_plan',
  MISSION_ATTEMPT_PENDING_END_KEY
]

export const AUTH_SESSION_STORAGE_KEYS = [
  'accessCodeData',
  'digipalzMissionRunRewardsV1',
  'isLoggingOut',
  'digipalz_retention_fired_this_session',
  'session_start',
  'emailNotificationResults',
  'verificationEmailData',
  MISSION_ATTEMPT_SESSION_KEY,
  MISSION_ATTEMPT_EXIT_REASON_KEY,
  MISSION_ATTEMPT_PENDING_END_KEY
]

export const AUTH_LOCAL_STORAGE_PREFIXES = ['digipalz_journey_sent_']
